import React from 'react';

interface IconProps {
  fill: string;
  height: string | number;
  width: string | number;
}

function StoreIcon({ fill, height, width }: IconProps) {
  return (
    <svg xmlns="http://www.w3.org/2000/svg" width={width} height={height} fill="none" viewBox="0 0 34 28">
      <path
        fill={fill}
        d="M27 27.333V7.917L19.75.667h-4.716L23.667 9.3v18.033h3.334zm6.667 0V5.15L29.184.667h-4.717l5.867 5.866v20.8h3.333zM10.334.667l-10 10v16.666h8.333V19h3.334v8.333h8.333V10.667l-10-10zm1.667 15H8.667v-3.334h3.334v3.334z"
      ></path>
    </svg>
  );
}

export default StoreIcon;
